const messages = {
    en: {
      aboutCookieTitle: "About Cookie",
      aboutCookieText: "What is a cookie? A cookie is a small file that can be placed on your device that allows us to recognise and remember you. It is sent to your browser and stored on your computer's hard drive or tablet or mobile device. When you visit our sites,  we may collect information from you automatically through cookies or similar technology. ",
    },
    ru: {
      aboutCookieTitle: "О файлах cookie",
      aboutCookieText: "Что такое cookie? Файл cookie - это небольшой файл, который может быть размещен на вашем устройстве и позволяет нам узнавать и запоминать вас. Он отправляется в ваш браузер и сохраняется на жестком диске вашего компьютера, планшете или мобильном устройстве. Когда вы посещаете наши сайты,  мы можем собирать информацию от вас автоматически с помощью файлов cookie или аналогичных технологий.",
    }
  };

  export default messages;